"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Popover = _interopRequireDefault(require("./Popover"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Label = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Label, _Component);

  var _super = _createSuper(Label);

  function Label() {
    var _this;

    (0, _classCallCheck2["default"])(this, Label);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          textColor = _this$props.textColor,
          backgroundColor = _this$props.backgroundColor,
          fontSize = _this$props.fontSize,
          fontWeight = _this$props.fontWeight,
          text = _this$props.text,
          width = _this$props.width,
          children = _this$props.children,
          style = _this$props.style,
          borderRadius = _this$props.borderRadius,
          popoverProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "textColor", "backgroundColor", "fontSize", "fontWeight", "text", "width", "children", "style", "borderRadius"]);
      var innerText = _react["default"].Children.toArray(children).length > 0 ? children : text;
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.root, className, style),
        position: "top center",
        popoverMaxWidth: 250
      }, popoverProps), innerText || children);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props2 = this.props,
          textColor = _this$props2.textColor,
          fontSize = _this$props2.fontSize,
          backgroundColor = _this$props2.backgroundColor,
          width = _this$props2.width,
          fontWeight = _this$props2.fontWeight,
          borderRadius = _this$props2.borderRadius;
      var fonts = this.context.theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: textColor,
          userSelect: "none",
          padding: "1px 13px",
          textRendering: "optimizeSpeed",
          fontSize: fontSize,
          fontFamily: fonts.semibold,
          fontWeight: fontWeight,
          borderRadius: borderRadius || 2,
          lineHeight: 1.5,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          backgroundColor: backgroundColor,
          width: width
        }
      });
    }
  }]);
  return Label;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  text: {
    required: false,
    type: "string",
    description: "Text to show inside the label. Can use this prop, or pass " + "the text with children"
  },
  textColor: {
    required: true,
    type: "string",
    description: "Text color of the label"
  },
  fontSize: {
    required: false,
    type: "number",
    defaultValue: "12",
    description: "Font size of the label"
  },
  backgroundColor: {
    required: true,
    type: "string",
    description: "Background color of the label"
  },
  width: {
    required: false,
    type: "number",
    description: "Width of the label"
  },
  borderRadius: {
    required: false,
    type: "number",
    defaultValue: "2",
    description: "Border radius of the label"
  }
}, _class3.demoProps = {
  textColor: "white",
  fontSize: 12,
  backgroundColor: "#2FB7EC"
}, _class3.demoRender = "\n<Label\n  textColor=\"white\"\n  fontSize={12}\n  backgroundColor=\"#2FB7EC\"\n>\n  I am a label\n</Label>\n  ", _class3.defaultProps = {
  fontSize: 12,
  position: "top center"
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Label;
exports["default"] = _default;